export const getCanonicalCountrySlug = (countryValue, countriesData) => {
    if (!countryValue) return countryValue;

    const countryEntries = Array.isArray(countriesData)
        ? countriesData.flatMap((item) => Object.entries(item || {}))
        : Object.entries(countriesData || {});
    const normalizedValue = String(countryValue).toLowerCase();
    const country = countryEntries.find(([key, item]) =>
        [key, item?.code, item?.slug].some(
            (value) => String(value || '').toLowerCase() === normalizedValue,
        ),
    )?.[1];

    // Return the matched slug, or null when the value does not correspond to
    // any known country. Callers fall back to a safe default (e.g. 'czechia')
    // via `|| 'czechia'`. Previously an unknown slug was echoed back verbatim,
    // which let a stale/renamed country slug (e.g. an old 'slovakia' value in
    // localStorage) leak into the URL and then 404 in useDefiningCity.
    return country?.slug || null;
};

export const getValidDistrictSlug = (citySlug, district, countriesData) => {
    if (!citySlug || !district?.slug) return undefined;

    const city = typeof citySlug === 'string'
        ? null
        : citySlug;
    const normalizedCitySlug =
        typeof citySlug === 'string' ? citySlug : citySlug?.slug;
    const countryEntries = Array.isArray(countriesData)
        ? countriesData.flatMap((item) => Object.entries(item || {}))
        : Object.entries(countriesData || {});
    const cityFromData = countryEntries
        .flatMap(([, country]) => country?.cities || [])
        .find((item) => item?.slug === normalizedCitySlug);
    const matchingDistrict = (cityFromData || city)?.districts?.find(
        (item) =>
            (district.id != null && String(item.id) === String(district.id)) ||
            item.slug === district.slug,
    );

    return matchingDistrict?.slug;
};

export const getLinksCitySlug = ({
    routeCitySlug,
    countriesData,
    currentCitySlug,
    selectedCountrySlug,
    pathname,
    isMainPage,
}) => {
    const routeBaseSlug = routeCitySlug?.split('_')[0];
    const pathSegments = (pathname || '').split('/').filter(Boolean);
    const hasLanguagePrefix = ['en', 'cz', 'ru', 'de', 'sk'].includes(pathSegments[0]);
    const pathCitySlug = pathSegments[hasLanguagePrefix ? 1 : 0];
    const isMainPageRoute =
        isMainPage ||
        pathname === '/' ||
        /^\/(en|cz|ru|de|sk)\/?$/.test(pathname || '') ||
        /^\/(?:(en|cz|ru|de|sk)\/)?filter\/[^/]+\/?$/.test(pathname || '') ||
        (!!routeBaseSlug && pathCitySlug === routeBaseSlug);

    if (isMainPageRoute) {
        if (currentCitySlug && (!routeBaseSlug || routeBaseSlug === currentCitySlug)) {
            return currentCitySlug;
        }
        return routeBaseSlug || currentCitySlug || 'czechia';
    }
    if (selectedCountrySlug) return selectedCountrySlug;
    if (!routeCitySlug) return 'czechia';

    const citySlug = routeBaseSlug;
    const countryEntries = Array.isArray(countriesData)
        ? countriesData.flatMap((item) => Object.entries(item || {}))
        : Object.entries(countriesData || {});
    const currentCountry = countryEntries.find(([, country]) =>
        country?.slug === citySlug ||
        country?.cities?.some((city) => city.slug === citySlug),
    );

    return currentCountry?.[1]?.slug || 'czechia';
};